import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Trash2, Mail } from "lucide-react";
import { toast } from "sonner";

const AdminNewsletter = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/admin/newsletter").then((r) => setItems(r.data || [])).catch(() => {}).finally(() => setLoading(false));
  };
  useEffect(load, []);

  const remove = async (id) => {
    if (!window.confirm("Delete?")) return;
    await api.delete(`/admin/newsletter/${id}`);
    toast.success("Removed");
    load();
  };

  const exportCsv = () => {
    const header = "email,source,created_at\n";
    const rows = items.map((i) => `${i.email},${i.source || ""},${i.created_at}`).join("\n");
    const blob = new Blob([header + rows], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = "newsletter-subscribers.csv"; a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div data-testid="admin-newsletter">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-display text-3xl font-black tracking-tight">Newsletter</h1>
          <p className="text-sm text-zinc-500 mt-1">{items.length} subscribers</p>
        </div>
        <button onClick={exportCsv} disabled={!items.length} className="border border-zinc-200 hover:border-orange-500 px-4 py-2 rounded-md font-semibold text-sm disabled:opacity-50">Export CSV</button>
      </div>

      <div className="mt-8 bg-white border border-zinc-200 rounded-md">
        {loading ? (
          <div className="p-10 text-center text-zinc-500 text-sm">Loading…</div>
        ) : items.length === 0 ? (
          <div className="p-10 text-center text-zinc-500 text-sm">No subscribers yet.</div>
        ) : (
          <div className="divide-y divide-zinc-100">
            {items.map((s) => (
              <div key={s.id} className="px-6 py-4 flex items-center justify-between gap-4">
                <div>
                  <div className="font-semibold text-zinc-900 inline-flex items-center gap-2"><Mail size={14} className="text-orange-500" /> {s.email}</div>
                  <div className="text-xs text-zinc-500 mt-1">{s.source} · {new Date(s.created_at).toLocaleString()}</div>
                </div>
                <button onClick={() => remove(s.id)} className="p-2 rounded-md hover:bg-red-50 text-red-600"><Trash2 size={16} /></button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminNewsletter;
